var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "planes-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Создание плоскостей")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-step-two-img-container planes-btn-grid" },
        [
          _c("div", { staticClass: "planes-btn-grid-element" }, [
            _c(
              "div",
              {
                staticClass: "planes-btn",
                on: {
                  click: function($event) {
                    return _vm.createPlane("wall")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "planes-btn-img",
                  attrs: { src: _vm.urlForStatic("/img/btn_walls.svg") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "planes-btn-text" }, [_vm._v("Стены")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "planes-btn-grid-element" }, [
            _c(
              "div",
              {
                staticClass: "planes-btn",
                on: {
                  click: function($event) {
                    return _vm.createPlane("window")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "planes-btn-img",
                  attrs: { src: _vm.urlForStatic("/img/btn_window.svg") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "planes-btn-text" }, [
              _vm._v("Оконные проёмы")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "planes-btn-grid-element" }, [
            _c(
              "div",
              {
                staticClass: "planes-btn",
                on: {
                  click: function($event) {
                    return _vm.createPlane("door")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "planes-btn-img",
                  attrs: { src: _vm.urlForStatic("/img/btn_door.svg") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "planes-btn-text" }, [
              _vm._v("Дверные проёмы")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "planes-btn-grid-element" }, [
            _c(
              "div",
              {
                staticClass: "planes-btn",
                on: {
                  click: function($event) {
                    return _vm.moveToPreAdditional()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "planes-btn-img",
                  attrs: { src: _vm.urlForStatic("/img/btn_additions.svg") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "planes-btn-text" }, [
              _vm._v("Доборные элементы")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "planes-btn-grid-element" }, [
            _c(
              "div",
              {
                staticClass: "planes-btn",
                on: {
                  click: function($event) {
                    return _vm.createPlane("cutout")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "planes-btn-img",
                  attrs: { src: _vm.urlForStatic("/img/overlap.svg") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "planes-btn-text" }, [
              _vm._v("Коррекция перекрытия")
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-text-area" }, [
        _vm._v(
          "Чтобы перейти к созданию плоскости, выберите тип зоны, которую Вы собираетесь выделить в меню, расположенном выше."
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v(
        "Для точной и качественной визуализации дизайна необходимо определить плоскости различных зон вашего объекта:\n        "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("стены")]),
      _vm._v(", "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("дверные")]),
      _vm._v(" и "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("оконные проемы")
      ]),
      _vm._v("\n        , а также зоны "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("доборных элементов")
      ]),
      _vm._v(" и области, "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("перекрываемые")
      ]),
      _vm._v(" объектами переднего плана.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }